import axios from "axios";

import {
  SUBSCRIPTION_DETAILS_ARE_FETCHING,
  SUBSCRIPTION_DETAILS_HAS_FETCHED_SUCCESS,
  SUBSCRIPTION_DETAILS_HAS_FETCHED_ERROR,
  SUBSCRIPTION_DETAILS_CLEAR,
} from "./../../../constants/actionTypes/actionTypes";

export const getUserSubscriptionDetails = () => (dispatch, getState) => {
  const { api } = getState().paths;
  const url = `${api}/subscription/details`;
  dispatch({ type: SUBSCRIPTION_DETAILS_ARE_FETCHING });
  return axios
    .get(url)
    .then((response) => {
      dispatch({
        type: SUBSCRIPTION_DETAILS_HAS_FETCHED_SUCCESS,
        data: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: SUBSCRIPTION_DETAILS_HAS_FETCHED_ERROR,
        error: error.toString(),
      });
    });
};

export const clearSubscriptionDetails = () => ({
  type: SUBSCRIPTION_DETAILS_CLEAR,
});
